/**
 * Dashboard - sends you to the right dashboard for your account type
 * ------------------------------------------------------------------
 * Both kinds of account use the address /dashboard, so this small file just
 * picks which one to draw. Keeps the navbar link simple for everyone.
 */

import { useAuth } from '../hooks/useAuth';
import UserDashboard from './UserDashboard';
import StudentDashboard from './StudentDashboard';
import Loader from '../components/Loader';

export default function Dashboard() {
  const { user, loading } = useAuth();

  if (loading || !user) return <Loader />;

  return user.role === 'student' ? <StudentDashboard /> : <UserDashboard />;
}
